import { cva } from "class-variance-authority";

// The indicator stays inside the padding on its own (contain mode); the clip only guards sub-pixel rounding.
export const trackCva = cva(
  "relative overflow-hidden rounded-xl bg-gray-100 p-1 dark:bg-dark-900",
  {
    variants: {
      layout: {
        wrap: "flex flex-wrap gap-1",
        grid: "grid grid-cols-1 gap-1",
      },
      columns: {
        2: null,
        3: null,
        4: null,
      },
      compact: {
        true: "w-fit",
        false: "w-full",
      },
      disabled: {
        true: "pointer-events-none opacity-50",
        false: null,
      },
    },
    compoundVariants: [
      { layout: "grid", columns: 2, className: "sm:grid-cols-2" },
      { layout: "grid", columns: 3, className: "sm:grid-cols-3" },
      { layout: "grid", columns: 4, className: "sm:grid-cols-4" },
    ],
    defaultVariants: {
      layout: "wrap",
      compact: false,
      disabled: false,
    },
  },
);

export const optionCva = cva(
  [
    "relative z-10 flex min-h-10 min-w-0 flex-col justify-center gap-0.5 rounded-lg px-3 py-1.5",
    "transition-[color,background-color] duration-280 ease-out motion-reduce:transition-none",
    "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-500",
    "focus-visible:ring-offset-1 focus-visible:ring-offset-gray-100 dark:focus-visible:ring-offset-dark-900",
  ],
  {
    variants: {
      selected: {
        true: "text-(--text)",
        false: "text-gray-600 hover:bg-white/70 dark:text-gray-300 dark:hover:bg-dark-700/60",
      },
      indicator: {
        true: null,
        false: null,
      },
      grow: {
        true: "min-w-[6.5rem] flex-1",
        false: "w-full",
        auto: "w-auto",
      },
      align: {
        start: "items-start text-left",
        center: "items-center text-center",
      },
      disabled: {
        true: "cursor-not-allowed opacity-50",
        false: null,
      },
    },
    compoundVariants: [
      {
        selected: true,
        indicator: false,
        className: "bg-white shadow-xs ring-1 ring-primary-500 dark:bg-dark-700",
      },
    ],
    defaultVariants: {
      selected: false,
      indicator: false,
      grow: true,
      align: "start",
      disabled: false,
    },
  },
);

export const indicatorCva = cva("pointer-events-none absolute left-0 top-0 z-0");

export const indicatorSurfaceCva = cva(
  "block size-full rounded-lg bg-white shadow-xs ring-1 ring-primary-500 dark:bg-dark-700",
);
